import { render, staticRenderFns } from "./twitch.vue?vue&type=template&id=e887e02c&"
import script from "./twitch.vue?vue&type=script&lang=js&"
export * from "./twitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports